import type { FlightResponse } from 'generatedTypes/flight/models';
import { formatToUSDate } from 'utils/dateTimeUtils/dateFormatUtil';

const getFlightGroupKey = (flight: FlightResponse): string =>
    formatToUSDate(new Date(flight.startTime));

export default getFlightGroupKey;
